import { useQuery } from "@tanstack/react-query";
import { useContext, useEffect, useState } from "react";
import { DDD } from "../../lib/ddd/ddd";
import LoadingDots from "../UI/LoadingDots";
import classes from "./ServicesComponents.module.scss";
import { Col, Container, Row } from "react-bootstrap";
import { ReactComponent as CopyBtn } from "../../assets/copy.svg";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import {  ThreeDots } from "react-loader-spinner";
import { Skeleton } from "@mui/material";
import { useTranslation } from 'react-i18next';
import {QRCodeSVG} from 'qrcode.react';
import { OrgIdContext } from "../../store/orgId_context";
const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const ddd = new DDD(apiRequestAddress);

const ApiKey = () =>{
    const {connectionKey, isMaintainer, sessionInfo, connectionKeyMode,setConnectionKeyModeHandler} = useContext(OrgIdContext);
    const [active, setActive] = useState(false);
    const [checked, setChecked] =useState(false);
    const [working, setWorking] = useState(false);
    const [deviceId, setDeviceId] = useState();
    const [copied, setCopied] = useState();
    const [error, setError] = useState();
    const [qrdata, setQrdata] = useState("");
    const { t } = useTranslation();

    const transDataArgs = { type : "profile" };
    const {isPending , data } = useQuery({
        queryKey: ["EUeInvoices.GetTransformerData",transDataArgs],
        queryFn: () => ddd.Rpc_ExecuteExtension("EUeInvoices.GetTransformerData", transDataArgs)
    })

    useEffect(() => {
        let params={
            taxNo: sessionInfo?.Organization?.TaxNo,
            orgTitle: sessionInfo?.Organization?.Title,
            connectionKey: connectionKey,
            service : sessionInfo.BaseUrl
        }
        setQrdata(JSON.stringify(params));
    }, [connectionKey, sessionInfo]);

    useEffect(() => {
        console.log(data);
        console.log(connectionKey);
        console.log(connectionKeyMode)
        if(!isPending && data){
            setActive(data.result?.Result?.device?.Mode === "PROD");
            setChecked(data.result?.Result?.device?.Mode === "PROD");
            setDeviceId(data.result?.Result?.device?.Id);
        }
    }, [isPending, data]);

    const selectedChange = (e) =>{
        setChecked(prev=>!prev);
        changeMode(e.target.checked);
    }

    const changeMode = (mode) =>{
        setError(null);
        setWorking(true);
        let params = {
            DeviceId: deviceId,
        }
        params.Mode = mode ? "TEST" : "PROD";
        ddd.Rpc_ExecuteExtension("EUeInvoices.ChangeMode", params).then(res => {
            setWorking(false);
            if(!res || res.result?.Status === "Error"){
                setError(res.result?.Reason || t("An unknown error occured. Please contact administrator."))
                setActive(!mode);
                setChecked(!mode);
            }else{
                setError(null);
            }
        });
    }

    const onCopyClickHandler = () =>{
        navigator.clipboard.writeText(deviceId);
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 1500)
    }
    

    return (
        <>
        <div className="d-flex">
        <div className="mb-5 col-xl-9 col-lg-10">
            <h2 className={classes.subtitle}>{t("Your connection API key")}</h2>
            <div>
            {t(`This is your company's Connection Key. All invoices sent from your solution to our service using this key will automatically be sent to the test
            (and not the production) environment - until you arrange the necessary communication credentials and switch your company to the production mode 
            of operation.`)}
            </div>
            
            
            <Container className="pt-3">
                <Row className={`${classes["apiKeyRow"]}`}>
                    <Col className={`col-3`}>{t("Current mode")}</Col>
                    <Col>Key</Col>
                    {/* <Col className={`col-2`}>
                        {isPending && <Skeleton/>}
                        {!isPending && !active && "Activate"}
                    </Col> */}
                </Row>
                <Row className="pt-2" style={{backgroundColor:"white", borderRadius:"0px 0px 15px 15px"}}>
                    <Col className={`col-3 text-center`}>
                        {/* {isPending && <Skeleton height="5rem"/>} */}
                        {!isPending && connectionKeyMode==="TEST" && <ManageAccountsIcon className="main-blue" style={{width:"4rem", height:"4rem"}}/>}
                        {!isPending && connectionKeyMode==="PROD" &&<DoneOutlineIcon className="main-green" style={{width:"3rem", height:"3rem"}}/>}
                        <div>
                            <span className={classes["apiKeyProdText"]}>{connectionKeyMode==="PROD" && t("Production")}</span>
                            <span className={classes["apiKeyTestText"]}>{connectionKeyMode==="TEST" && t("Test")}</span>
                        </div>
                    </Col>
                    <Col className={`${classes["connKeyBtnNew"]}`} onClick={onCopyClickHandler}>
                        {/* {!deviceId && <Skeleton/>} */}
                        {connectionKey}
                        {connectionKey && <CopyBtn height="15" className="icon-blue" style={{paddingLeft:"1rem"}} />}
                        {copied && <><span className={classes["copiedText"]}>{t("Copied!")}</span></>}
                    </Col>
                    {/* <Col className={`col-2`}>
                    <div className="form-check form-switch text-center">
                        {isPending && <Skeleton/>}
                        {!isPending && !active && <input className="form-check-input" style={{transform:"scale(1.5)", float:"none"}} checked={checked} type="checkbox" role="switch" onChange={selectedChange}/>}
                    </div>
                    {working &&
                        <div className="text-center">
                            <ThreeDots height="50" width="50" color="#005683" wrapperStyle={{justifyContent:"center"}}/>
                        </div>}
                    </Col> */}
                </Row>
                {error && 
                <Row className={classes["errorAlert"]}>
                    <Col className="col-1"><ErrorOutlineIcon style={{width:"2rem", height:"2rem", color:"red"}} /></Col>
                    <Col>{error}</Col>
                </Row>}
            </Container>
            
        </div>
            {isMaintainer && false && <>
            <div style={{marginLeft:"1rem",alignSelf:"center", textAlign:"center"}}>
                <div>Scan to connect</div>
                <QRCodeSVG value={qrdata} />
            </div>
            </>}
        </div>
        </>
    )
}

export default ApiKey;